import { Positioned } from '../pages/positionedTypes';

export function sortAsc(p1: Positioned, p2: Positioned): number {
  if (p1.position > p2.position) {
    return 1;
  }

  if (p1.position < p2.position) {
    return -1;
  }

  return 0;
}
